<template>
  <modal v-model="show" max-width="1024px" hide-actions no-padding>
    <alert ref="msg" />
    <div>
      <v-toolbar tabs dark color="primary">
        <v-icon>{{ settingsLoaded ? 'settings' : 'warning' }}</v-icon>
        <v-toolbar-title>
          {{ $t('Settings') }}
          <span v-if="!settingsLoaded" class="ml-2">... {{ $t('Inactive contract!') }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn icon @click="save"><v-icon>save</v-icon></v-btn> -->
        <v-btn icon @click="show = false"><v-icon>close</v-icon></v-btn>

        <template v-slot:extension>
          <v-tabs v-model="tab" color="primary" slider-color="white" dark centered grow>
            <v-tab>{{ $t('Preferences') }}</v-tab>
            <v-tab>{{ $t('Email notifications') }}</v-tab>
            <v-tab>{{ $t('WMS notifications') }}</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container grid-list-lg>
            <v-layout row wrap align-center class="border-bottom">
              <v-flex xs12>
                <v-select v-model="parcelDimUnit" :items="lists.parcelDimUnit" :label="$t('Parcel dimentions unit')"
                  item-text="id" item-value="id"
                  @change="storeLocalPrefs('parcelDimUnit')"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="pb-4 d-flex align-center flex-wrap">
                <v-subheader>{{ $t("Blanks to download") }}</v-subheader>
                <div v-for="item in lists.downloadBlanks.items" :key="item.title">
                  <v-icon size="20" class="mr-2">{{ item.icon ? item.icon : lists.downloadBlanks.defaults.icon }}</v-icon>
                  <a :href="item.href" :target="item.target ? item.target : lists.downloadBlanks.defaults.target">{{ item.title }}</a>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center>
              <v-flex xs12 sm4>
                <v-checkbox v-model="settings.package_return" :label="$t('Package return')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm4>
                <v-checkbox v-model="settings.proof_of_delivery" :label="'POD ' + $t('Proof of delivery')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm4>
                <v-checkbox v-model="settings.receipt_required" :label="$t('Receipt required')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select v-model="settings.payer_type" :items="lists.payer_type" :label="$t('Payer type')" :disabled="settingsEditDisabled">
                  <template v-slot:selection="{ item }">
                    {{ $t('payer_type.' + item) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t('payer_type.' + item) }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select v-model="settings.payment_type" :items="lists.payment_type" :label="$t('Payment type')" :disabled="settingsEditDisabled">
                  <template v-slot:selection="{ item }">
                    {{ $t('payment_type.' + item) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t('payment_type.' + item) }}
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container grid-list-lg>
            <v-layout row wrap align-center>
              <v-flex xs12>
                <email-selector v-model="settings.notification_contact" :label="$t('Email for notification')" :disabled="settingsEditDisabled"
                  :rules="rules.email"
                  key="notification_contact"
                ></email-selector>
              </v-flex>
              <v-flex xs12>
                <email-selector v-model="settings.notification_cod_contact" :label="$t('Email for COD notification')" :disabled="settingsEditDisabled"
                  :rules="rules.email"
                  key="notification_cod_contact"
                ></email-selector>
              </v-flex>

              <v-flex xs12 sm3>
                <v-subheader>{{ $t('Orderer notification') }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.orderer_notification_accepted_order" :label="$t('Order accepted')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.orderer_notification_delivery" :label="$t('Shipment delivered')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.orderer_notification_failure" :label="$t('Shipment not delivered')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm3>
                <v-subheader>{{ $t('Sender notification') }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.source_notification_delivery" :label="$t('Shipment delivered')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.source_notification_failure" :label="$t('Shipment not delivered')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.source_notification_cod_paid" :label="$t('COD Paid ')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm3>
                <v-subheader>{{ $t('Receiver notification') }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.target_notification_collect" :label="$t('Shipment collected')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.target_notification_delivery" :label="$t('Pending delivery')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox v-model="settings.target_notification_failure" :label="$t('Shipment not delivered')" :disabled="settingsEditDisabled"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              3. Известия за складови операции (WMS)
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Alert from "@/components/Alert.vue";
import EmailSelector from "@/components/VEmailSelector.vue";
import { settings } from "@/resources";
import { extractBodyErrorMessages, validateEmail } from "@/components/util";
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'settings',
  components: {
    Modal,
    Alert,
    EmailSelector
  },
  props: ['value'],
  data() {
    return {
      show: this.value,
      tab: null,
      settingsLoaded: false,
      // Local settings
      parcelDimUnit: 'm',
      // Lists
      lists: {
        parcelDimUnit: [
          { id: "m",  ratio: 0 },
          { id: "cm", ratio: 0.01 }
        ],
        downloadBlanks: {
          defaults: { icon: "fa-file-download", target: "_blank" },
          items: [
            { icon: "fa-file-pdf",  title: this.$t("Blank for International transport"), href: "./static/ZayavkaZaMezhdunarodenTransport.pdf" },
            { icon: "fa-file-word", title: this.$t("Blank for Claim"),                   href: "./static/OD_17-03_Pretentsia.docx" },
          ],
        },
        payer_type: ['SENDER', 'RECEIVER', 'BY_CONTRACT'],
        payment_type: ['CASH', 'BANK_TRANSFER'],
      },
      rules: {
        email: [(v) => !v || validateEmail(v) || this.$t("Invalid email address")],
      }
    }
  },
  computed: {
    ...mapGetters(['settings', 'requestPrefs']),
    settingsEditDisabled() {
      return !this.settingsLoaded;
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
      if (val) {
        this.init();
      }
    },
    settings: {
      handler(val) {
        // console.log('watch store.settings', val, this.settingsLoaded);
        if (this.settingsLoaded) {
          this.save();
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['loadSettings', 'updateRequestPrefs', 'loadUserInfo']),
    restoreRequestPrefs(failValue) {
      let prefs = null;
      try {
        prefs = JSON.parse(this.requestPrefs);
      } catch(e) {
        console.log("ERROR: Request preferences cannot be parsed!");
        prefs = failValue;
      }
      return prefs;
    },
    storeLocalPrefs(item) {
      let prefs = this.restoreRequestPrefs({});

      if (item === 'parcelDimUnit') {
        if (!prefs.units) {
          prefs.units = {}
        }
        prefs.units.parcelDims = this.parcelDimUnit;
      }

      this.updateRequestPrefs( JSON.stringify(prefs) );
    },
    restoreLocalPrefs() {
      let prefs = this.restoreRequestPrefs(null);

      if (prefs && !!prefs.units && !!prefs.units.parcelDims) {
        this.parcelDimUnit = prefs.units.parcelDims;
      }
    },
    init() {
      this.restoreLocalPrefs();
      if (!this.settingsLoaded) {
        this.load();
      }
    },
    load() {
      this.loadSettings().then(res => {
        if (res && Object.keys(res).length) {
          this.settingsLoaded = true;
        }
      }).catch(err => {
        console.log('Error loading settings', err);
        this.settingsLoaded = false;
        // this.$refs.msg.popup(extractBodyErrorMessages(err.body) || err.body || this.$t('Error loading settings'), 'error');
      });
    },
    save() {
      const params = JSON.stringify(this.settings);
      // console.log('save settings', params);
      settings.save({}, params).then(res => {
        this.loadUserInfo().then(res => {
          // console.log('userInfo res (fired by Settings)', res.options);
        }).catch((err) => {
          console.log('userInfo err (fired by Settings)', err);
        });
      }).catch(err => {
        console.log('Error saving settings', err);
        this.$refs.msg.popup(extractBodyErrorMessages(err.body) || this.$t('Error saving settings'), 'error');
      });
    },
    test(evt) {
      this.$refs.msg.popup(evt, 'error');
      console.log('test', evt);
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>
.border-bottom:after {
  border-bottom: solid 1px rgba(0, 0, 0, 0.14);
  content: '';
  width: 100%;
  margin: 0 8px;
}
</style>